const reducer = (state, action) => ({
  ...state,
  fulfilmentType: action.fulfilmentType,
});

export default reducer;
